/**
 * @generated SignedSource<<eecb90613aea9fa224bee5caee9028d6>>
 * @relayHash 0ec72d9f874faceb8de2dbd022c8f69b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ece974e6a17215202b7e94c69e06a16ab1b155009ff6d469e08b78a143feb38

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2ece974e6a17215202b7e94c69e06a16ab1b155009ff6d469e08b78a143feb38",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
